import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { cartIdStore } from 'src/api/orderIdStore';
import { WinbackOfferConfirmationPage } from 'src/apps/checkout/app/pages/WinbackOffer.Confirmation';

const searchSchema = z.object({
  setup_intent_client_secret: z.string(),
  setup_intent: z.string(),
  redirect_status: z.string(),
});

export const Route = createFileRoute(
  '/_auth/_only-header/store/methods-offer/confirmation'
)({
  validateSearch: zodValidator(searchSchema),
  beforeLoad({ search }) {
    if (!cartIdStore.get()) {
      throw redirect({ to: '/subscriptions' });
    }
    if (search.redirect_status === 'failed') {
      throw redirect({
        to: '/store/methods-offer/checkout',
        search: { redirect_status: 'failed' },
      });
    }
  },
  component: () => <WinbackOfferConfirmationPage />,
});
